import {
    useState,
    forwardRef,
    useImperativeHandle
} from "react"

const PasswordInput = forwardRef(({ isMandatory = true }, ref) => {
    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [showPassword, setShowPassword] = useState(false)
    const [showConfirm, setShowConfirm] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            let isValid = true
            let message = ""

            if (isMandatory && (!password || !confirmPassword)) {
                isValid = false
                message = "Password and Confirm Password are required"
            } else if (password !== confirmPassword) {
                isValid = false
                message = "Passwords do not match"
            } else {
                message = ""
            }

            setErrorMessage(message)

            return { isValid, value: password, errorMessage: message }
        },
        resetData: () => {
            setPassword("")
            setConfirmPassword("")
            setShowPassword(false)
            setShowConfirm(false)
            setErrorMessage("")
        },
    }))

    return (
        <div className="space-y-4">
            {/* Password Field */}
            <div className="relative">
                <label className="block text-sm font-medium text-gray-700">
                    Password {isMandatory ? "*" : ""}
                </label>
                <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter password"
                    className="mt-1 w-full border rounded-md p-2 pr-10"
                    autoComplete="off"
                />
                <button
                    type="button"
                    onClick={() => setShowPassword((prev) => !prev)}
                    className="absolute top-[35px] right-3 text-gray-500"
                >
                    {showPassword ? "Hide" : "Show"}
                </button>
            </div>

            {/* Confirm Password Field */}
            <div className="relative">
                <label className="block text-sm font-medium text-gray-700">
                    Confirm Password {isMandatory ? "*" : ""}
                </label>
                <input
                    type={showConfirm ? "text" : "password"}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Re-enter password"
                    className="mt-1 w-full border rounded-md p-2 pr-10"
                    autoComplete="off"
                />
                <button
                    type="button"
                    onClick={() => setShowConfirm((prev) => !prev)}
                    className="absolute top-[35px] right-3 text-gray-500"
                >
                    {showConfirm ? "Hide" : "Show"}
                </button>
            </div>

            {/* Error Message */}
            {errorMessage && (
                <p className="text-sm text-red-600">{errorMessage}</p>
            )}
        </div>
    )
})

export default PasswordInput
